import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface StateState {
  editId: number | null
  isCreateModalOpen: boolean
}

const initialState: StateState = {
  editId: null,
  isCreateModalOpen: false
}

const stateSlice = createSlice({
  name: 'state',
  initialState,
  reducers: {
    setEditId: (state, action: PayloadAction<number | null>) => {
      state.editId = action.payload
    },
    setIsCreateModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isCreateModalOpen = action.payload
    }
  }
})

export const stateActions = stateSlice.actions
export const { reducer: stateReducer } = stateSlice
